import { render, staticRenderFns } from "./ExhibitPill.vue?vue&type=template&id=5c7f8b51&scoped=true&"
import script from "./ExhibitPill.vue?vue&type=script&lang=js&"
export * from "./ExhibitPill.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitPill.vue?vue&type=style&index=0&id=5c7f8b51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f8b51",
  null
  
)

export default component.exports